<div class="header" >
  <i class="fa-sharp fa-regular fa-xmark icon pointer" (click)="close()"></i>
</div>
<ng-container *ngIf="!loading else loadingBox">
  <div class="body">
    <div class="date">{{callDate | date : 'M/d/yy, h:mm a'}}</div>
    <div class="title" [ngClass]="{'mobileTitle': isMobile}">{{'ZOOM_CALL_TRANSCRIPT.TITLE' | translate }}</div>
    <div class="title" [ngClass]="{'mobileTitle': isMobile}">{{'ZOOM_CALL_TRANSCRIPT.SUB_TITLE' | translate : {name: customerData?.name} }}</div>
    <div class="transcript">
      <div class="transcriptItem" *ngFor="let item of callTranscript" [ngClass]="{'leftTranscriptItem':  item?.name!='Home365'}">
        <div class="transcriptItemImage">
          <ng-container *ngIf="item?.name!='Home365'">
            <div class="circle-name-ms user-img" [ngClass]="{'circle-name-s': isMobile}">
              {{ getShortName(item?.name) }}
            </div>
          </ng-container>
          <ng-container *ngIf="item?.name === 'Home365'"><img class="circle-name-ms" [ngClass]="{'circle-name-s': isMobile}" [src]="'./assets/img/home365_logo_small.svg'" alt="image"/></ng-container>
        </div>
        <div class="transcriptItemBody" [ngClass]="{'left': item?.name!='Home365'}">
          <div class="header">
            <div class="name">{{item?.name}}</div>
            <div class="date">{{item?.time}}</div>
          </div>
          <div class="text">{{item?.text}}</div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingBox>
  <div class="spinnerBox" >
    <home365-loader [white]="false" [size]="'xxl'"></home365-loader>
  </div>
</ng-template>